import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { TABS_BASE_CLASSNAME } from './Constants';
import { createTabs } from './Tabs';
createComponents(".".concat(TABS_BASE_CLASSNAME), createTabs, NO_PATTERN_BUSINESS_LOGIC);
